<template>
    <div class="min-h-screen bg-gray-50">
        <div class="container mx-auto p-2 sm:p-6">
            <h2 class="text-sm sm:text-base font-semibold text-center mt-2 mb-2 sm:mb-4 text-gray-800">상품이미지 다운로드</h2>

            <div class="flex flex-row flex-nowrap gap-2 sm:gap-3 justify-center mb-4 sm:mb-8">
                <div class="relative flex-shrink-0">
                    <select v-model="searchCriteria.brand"
                        class="w-[80px] sm:w-36 h-8 sm:h-10 pl-2 pr-5 sm:pl-3 sm:pr-8 text-xs sm:text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white">
                        <option v-for="option in brandOptions" :key="option.value" :value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                    <div class="absolute inset-y-0 right-0 flex items-center pr-1 sm:pr-2 pointer-events-none">
                        <svg class="w-3 h-3 sm:w-4 sm:h-4 text-gray-400" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="relative flex-shrink-0">
                    <select v-model="searchCriteria.season"
                        class="w-[80px] sm:w-36 h-8 sm:h-10 pl-2 pr-5 sm:pl-3 sm:pr-8 text-xs sm:text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white">
                        <option v-for="option in seasonOptions" :key="option.value" :value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                    <div class="absolute inset-y-0 right-0 flex items-center pr-1 sm:pr-2 pointer-events-none">
                        <svg class="w-3 h-3 sm:w-4 sm:h-4 text-gray-400" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="relative flex-shrink-0">
                    <select v-model="searchCriteria.year"
                        class="w-[80px] sm:w-36 h-8 sm:h-10 pl-2 pr-5 sm:pl-3 sm:pr-8 text-xs sm:text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white">
                        <option v-for="option in yearOptions" :key="option.value" :value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                    <div class="absolute inset-y-0 right-0 flex items-center pr-1 sm:pr-2 pointer-events-none">
                        <svg class="w-3 h-3 sm:w-4 sm:h-4 text-gray-400" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <button @click="handleSearch" :disabled="showLoading"
                    class="flex-shrink-0 h-8 sm:h-10 px-2 sm:px-4 text-xs sm:text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200">
                    검색
                </button>
            </div>

            <div v-if="show" class="mb-6">
                <input v-model="searchCriteria.keyword" placeholder="목록에서 스타일코드, 품명, 색상 등 원하시는 검색어를 입력해주세요"
                    class="w-full p-2 sm:p-3 text-xs sm:text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            </div>

            <div v-if="showLoading" class="text-center py-8">
                <div class="animate-spin rounded-full h-10 w-10 border-4 border-blue-500 border-t-transparent mx-auto">
                </div>
            </div>

            <div v-if="show" class="mb-4">
                <p class="text-xs sm:text-sm text-gray-600 mb-3">전체 | {{ filteredProducts.length }} SKU</p>
                <div class="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200">
                    <div class="overflow-x-auto">
                        <table class="w-full">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th
                                        class="px-2 sm:px-4 py-2 sm:py-3 text-left text-[11px] sm:text-xs md:text-sm font-medium text-gray-500">
                                        제품사진
                                    </th>
                                    <th class="sm:hidden px-2 py-2 text-left text-[11px] font-medium text-gray-500">
                                        품명/스타일코드
                                    </th>
                                    <th
                                        class="hidden sm:table-cell px-2 sm:px-4 py-2 sm:py-3 text-left text-[11px] sm:text-xs md:text-sm font-medium text-gray-500">
                                        품명
                                    </th>
                                    <th
                                        class="hidden sm:table-cell px-2 sm:px-4 py-2 sm:py-3 text-left text-[11px] sm:text-xs md:text-sm font-medium text-gray-500">
                                        스타일코드
                                    </th>
                                    <th
                                        class="px-2 sm:px-4 py-2 sm:py-3 text-left text-[11px] sm:text-xs md:text-sm font-medium text-gray-500">
                                        컬러
                                    </th>
                                    <th
                                        class="px-2 sm:px-4 py-2 sm:py-3 text-left text-[11px] sm:text-xs md:text-sm font-medium text-gray-500">
                                        다운로드
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200">
                                <tr v-for="product in filteredProducts" :key="product.id"
                                    class="hover:bg-gray-50 transition-colors duration-150">
                                    <td class="px-2 sm:px-4 py-2 sm:py-3 cursor-pointer"
                                        @click="showDetailModal(product)">
                                        <div v-if="!product.imageError" class="w-12 h-12 sm:w-16 sm:h-16">
                                            <img :src="getImageUrl(product)" :alt="product.STY_NM"
                                                class="w-full h-full object-cover rounded-lg shadow-sm"
                                                @error="() => setDefaultImage(product)" />
                                        </div>
                                        <div v-else
                                            class="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-gray-100 rounded-lg">
                                            <span class="text-gray-400 text-[10px] sm:text-xs">이미지 없음</span>
                                        </div>
                                    </td>
                                    <td class="sm:hidden px-2 py-2 cursor-pointer" @click="showDetailModal(product)">
                                        <div class="text-[11px] sm:text-xs font-medium text-gray-900">{{ product.STY_NM
                                        }} | {{
                                                product.STY_CD }}</div>
                                    </td>
                                    <td class="hidden sm:table-cell px-2 sm:px-4 py-2 sm:py-3 text-[11px] sm:text-xs md:text-sm text-gray-900 cursor-pointer"
                                        @click="showDetailModal(product)">
                                        {{ product.STY_NM }}
                                    </td>
                                    <td class="hidden sm:table-cell px-2 sm:px-4 py-2 sm:py-3 text-[11px] sm:text-xs md:text-sm text-gray-900 cursor-pointer"
                                        @click="showDetailModal(product)">
                                        {{ product.STY_CD }}
                                    </td>
                                    <td class="px-2 sm:px-4 py-2 sm:py-3 cursor-pointer"
                                        @click="showDetailModal(product)">
                                        <span :class="getColorClass(product.COL_NM)"
                                            class="text-[10px] sm:text-xs md:text-sm color-badge">
                                            {{ product.COL_NM }}
                                        </span>
                                    </td>
                                    <td class="px-2 sm:px-4 py-2 sm:py-3">
                                        <button v-if="!product.imageError" @click.stop="handleDownload(product)"
                                            class="px-2 sm:px-3 py-1 sm:py-1.5 text-[10px] sm:text-xs md:text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 flex items-center gap-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-5 sm:w-5"
                                                fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div v-if="isLoading" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div class="bg-white p-6 rounded-lg shadow-xl">
                    <div class="flex flex-col items-center">
                        <div class="animate-spin rounded-full h-10 w-10 border-4 border-blue-500 border-t-transparent">
                        </div>
                        <p class="mt-3 text-sm text-gray-600">다운로드 중...</p>
                    </div>
                </div>
            </div>

            <!-- 상세 조회 모달 -->
            <div v-if="selectedProduct"
                class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                <div class="bg-white rounded-lg w-full max-w-3xl max-h-[90vh] flex flex-col">
                    <!-- 모달 헤더 -->
                    <div class="p-4 border-b border-gray-200 flex justify-between items-center flex-shrink-0">
                        <div>
                            <h3 class="text-lg sm:text-xl font-semibold text-gray-900">상품 상세 정보</h3>
                            <div class="mt-1 text-xs sm:text-sm text-gray-600">
                                <span class="font-medium">품명:</span> {{ selectedProduct.STY_NM }} |
                                <span class="font-medium">스타일코드:</span> {{ selectedProduct.STY_CD }} |
                                <span class="font-medium">컬러:</span> {{ selectedProduct.COL_NM }}
                            </div>
                        </div>
                        <button @click="closeModal" class="text-gray-400 hover:text-gray-500">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <!-- 모달 본문 -->
                    <div class="p-4 overflow-y-auto flex-grow">
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <!-- 썸네일 이미지 -->
                            <div class="border rounded-lg p-3">
                                <div class="text-sm font-medium mb-2">썸네일</div>
                                <img :src="getDetailImageUrl(selectedProduct, 'thumb')"
                                    class="w-full h-48 object-contain rounded"
                                    @error="handleImageError($event, '썸네일')" />
                            </div>
                            <!-- 상세컷 이미지 -->
                            <div class="border rounded-lg p-3">
                                <div class="text-sm font-medium mb-2">상세컷</div>
                                <img :src="getDetailImageUrl(selectedProduct, 'detail')"
                                    class="w-full h-48 object-contain rounded"
                                    @error="handleImageError($event, '상세컷')" />
                            </div>
                            <!-- 룩북 이미지 -->
                            <div class="border rounded-lg p-3">
                                <div class="text-sm font-medium mb-2">룩북</div>
                                <img :src="getDetailImageUrl(selectedProduct, 'lookbook')"
                                    class="w-full h-48 object-contain rounded"
                                    @error="handleImageError($event, '룩북')" />
                            </div>
                            <!-- 모델핏 이미지 -->
                            <div class="border rounded-lg p-3">
                                <div class="text-sm font-medium mb-2">모델핏</div>
                                <img :src="getDetailImageUrl(selectedProduct, 'model')"
                                    class="w-full h-48 object-contain rounded"
                                    @error="handleImageError($event, '모델핏')" />
                            </div>
                            <!-- 사이즈표 이미지 -->
                            <div class="border rounded-lg p-3">
                                <div class="text-sm font-medium mb-2">사이즈표</div>
                                <img :src="getDetailImageUrl(selectedProduct, 'size')"
                                    class="w-full h-48 object-contain rounded"
                                    @error="handleImageError($event, '사이즈표')" />
                            </div>
                        </div>
                    </div>
                    <!-- 모달 푸터 -->
                    <div class="p-4 border-t border-gray-200 flex justify-end flex-shrink-0">
                        <button @click="handleDownload(selectedProduct)"
                            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 flex items-center gap-2">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                            전체 다운로드
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import webhardAPI from '@/api/webhard';
import Swal from 'sweetalert2';

const brandOptions = [
    { value: '아가방', text: '아가방' },
    { value: '에뜨와', text: '에뜨와' },
    { value: '디즈니', text: '디즈니' }
];

const seasonOptions = [
    { value: '사계절', text: '사계절' },
    { value: 'S1', text: 'S1' },
    { value: 'M1', text: 'M1' },
    { value: 'A1', text: 'A1' },
    { value: 'W1', text: 'W1' }
];

const yearOptions = [
    { value: '2023', text: '2023' },
    { value: '2024', text: '2024' },
    { value: '2025', text: '2025' },
    { value: '2026', text: '2026' }
];

const brandCodes = {
    '아가방': '01',
    '에뜨와': '07',
    '디즈니': '79',
};

const seasonCodes = {
    '사계절': '0',
    'S1': '1',
    'M1': '3',
    'A1': '5',
    'W1': '7'
};

const yearCodes = {
    '2023': 'Q',
    '2024': 'R',
    '2025': 'S',
    '2026': 'T'
};

const img_brand = ref('');
const img_year = ref('');
const img_ss = ref('');
const products = ref([]);
const searchCriteria = ref({
    brand: '에뜨와',
    season: 'M1',
    year: '2025',
    keyword: '',
});

const isLoading = ref(false);
const show = ref(false);
const showLoading = ref(false);

const filteredProducts = computed(() => {
    if (!products.value) return [];
    return products.value.filter(product =>
        (searchCriteria.value.keyword === '' ||
            product.STY_NM?.toLowerCase().includes(searchCriteria.value.keyword.toLowerCase()) ||
            product.STY_CD?.toLowerCase().includes(searchCriteria.value.keyword.toLowerCase()) ||
            product.COL_NM?.toLowerCase().includes(searchCriteria.value.keyword.toLowerCase())
        )
    );
});

const getImageUrl = (product) => {
    const url = `https://item.nextmom.co.kr/magaline_img/goods/${img_brand.value}/${img_year.value}/thumb/${product.STY_CD}${product.COL_CD}.jpg`;
    // console.log('생성된 이미지 URL:', {
    //     url,
    //     params: {
    //         brand: img_brand.value,
    //         year: img_year.value,
    //         style: product.STY_CD,
    //         color: product.COL_CD
    //     }
    // });
    return url;
};

const handleSearch = async () => {
    showLoading.value = true;
    show.value = false;
    products.value = [];

    console.log('검색 파라미터:', {
        brand: searchCriteria.value.brand,
        brandCode: brandCodes[searchCriteria.value.brand],
        year: searchCriteria.value.year,
        yearCode: yearCodes[searchCriteria.value.year],
        season: searchCriteria.value.season,
        seasonCode: seasonCodes[searchCriteria.value.season]
    });

    switch (brandCodes[searchCriteria.value.brand]) {
        case '01':
            img_brand.value = 'agabang';
            break;
        case '07':
            img_brand.value = 'ettoi';
            break;
        case '79':
            img_brand.value = 'disney';
            break;
        default:
            img_brand.value = '';
    }

    img_year.value = searchCriteria.value.year;
    img_ss.value = seasonCodes[searchCriteria.value.season];

    console.log('이미지 URL 파라미터:', {
        img_brand: img_brand.value,
        img_year: img_year.value,
        img_ss: img_ss.value
    });

    try {
        console.log('API 호출 파라미터:', {
            br_cd: brandCodes[searchCriteria.value.brand],
            year_cd: yearCodes[searchCriteria.value.year],
            sesn_cd: seasonCodes[searchCriteria.value.season]
        });

        const response = await webhardAPI.getList(
            brandCodes[searchCriteria.value.brand],
            yearCodes[searchCriteria.value.year],
            seasonCodes[searchCriteria.value.season]
        );
        
        console.log('API 응답:', response);
        
        if (!response.data || response.data.length === 0) {
            await Swal.fire({
                title: '알림',
                text: '검색 결과가 없습니다.',
                icon: 'info',
                confirmButtonText: '확인'
            });
            show.value = false;
            return;
        }

        products.value = response.data.map(product => ({
            ...product,
            imageError: false
        }));
        show.value = true;
    } catch (err) {
        console.error('검색 실패:', err);
        await Swal.fire({
            title: '오류',
            text: '검색 중 오류가 발생했습니다.',
            icon: 'error',
            confirmButtonText: '확인'
        });
    } finally {
        showLoading.value = false;
    }
};

const handleDownload = async (product) => {
    isLoading.value = true;

    try {
        if (process.env.NODE_ENV !== 'production') {
            console.log('다운로드 매개변수:', {
                brand: img_brand.value,
                style: product.STY_CD,
                color: product.COL_CD,
                year: img_year.value,
                season: img_ss.value
            });
        }

        const response = await webhardAPI.getZip(
            img_brand.value,
            product.STY_CD,
            product.COL_CD,
            img_year.value,
            img_ss.value
        );

        const link = document.createElement('a');
        link.href = response.url;
        link.download = response.filename;
        link.click();

        URL.revokeObjectURL(link.href);
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('다운로드 실패:', err);
        }
        alert("다운로드 실패: " + err.message);
    } finally {
        isLoading.value = false;
    }
};

const getColorClass = (color) => {
    const colorMap = {
        'CREAM': 'badge-cream',
        'O/WHITE': 'badge-white',
        'PINK': 'badge-pink',
        'BEIGE': 'badge-beige',
        'GREEN': 'badge-green',
        'IVORY': 'badge-ivory',
        'MULTI': 'badge-multi',
        'L/BEIGE': 'badge-lbeige',
        'YELLOW': 'badge-yellow',
        'MINT': 'badge-mint',
        'NAVY': 'badge-navy',
        'RED': 'badge-red',
        'ORANGE': 'badge-orange',
        'BLUE': 'badge-blue',
        'D/BEIGE': 'badge-dbeige',
        'L/YELLOW': 'badge-lyellow'
    };
    return colorMap[color] || 'badge-default';
};

const setDefaultImage = (product) => {
    product.imageError = true;
};

const selectedProduct = ref(null);

const showDetailModal = (product) => {
    selectedProduct.value = product;
};

const closeModal = () => {
    selectedProduct.value = null;
};

const getDetailImageUrl = (product, type) => {
    const { brand, year, style, color, season } = getProductInfo(product);
    const ss_name = getSeason(season);
    const ss_name2 = getSeasonShort(season);

    switch (type) {
        case 'thumb':
            return `https://item.nextmom.co.kr/magaline_img/goods/${brand}/${year}/thumb/${style}${color}.jpg`;
        case 'detail':
            return `https://item.nextmom.co.kr/magaline_img/goods/${brand}/${year}/${style}${color}.jpg`;
        case 'lookbook':
            return `https://item.nextmom.co.kr/magaline_img/goods/${brand}/${year}/${brand}_${year}_${ss_name}.jpg`;
        case 'model':
            return `https://item.nextmom.co.kr/magaline_img/goods/${brand}/${year}/${ss_name2}_model.jpg`;
        case 'size':
            return `https://item.nextmom.co.kr/magaline_img/goods/${brand}/${year}/${brand}_bottom_new.jpg`;
        default:
            return '';
    }
};

const getProductInfo = (product) => {
    return {
        brand: img_brand.value,
        year: img_year.value,
        style: product.STY_CD,
        color: product.COL_CD,
        season: img_ss.value
    };
};

const getSeason = (season) => {
    switch (season) {
        case '1': return 'spring';
        case '3': return 'summer';
        case '5': return 'fall';
        case '7': return 'winter';
        default: return '';
    }
};

const getSeasonShort = (season) => {
    return ['1', '3'].includes(season) ? 'ss' : 'fw';
};

const handleImageError = (event, type) => {
    event.target.src = ''; // 에러 이미지 대체
    event.target.classList.add('bg-gray-100');
    event.target.classList.add('flex');
    event.target.classList.add('items-center');
    event.target.classList.add('justify-center');
    event.target.innerHTML = `<span class="text-gray-400 text-xs">${type} 이미지 없음</span>`;
};
</script>

<style scoped>
.color-badge {
    @apply px-1.5 sm:px-3 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-xs font-medium inline-block whitespace-nowrap;
}

.badge-cream {
    @apply bg-yellow-100 text-yellow-800;
}

.badge-white {
    @apply bg-gray-100 text-gray-800;
}

.badge-pink {
    @apply bg-pink-100 text-pink-800;
}

.badge-beige {
    @apply bg-yellow-50 text-yellow-700;
}

.badge-green {
    @apply bg-green-100 text-green-800;
}

.badge-ivory {
    @apply bg-yellow-50 text-yellow-700;
}

.badge-multi {
    @apply bg-gray-100 text-gray-800;
}

.badge-lbeige {
    @apply bg-yellow-50 text-yellow-700;
}

.badge-yellow {
    @apply bg-yellow-100 text-yellow-800;
}

.badge-mint {
    @apply bg-green-100 text-green-800;
}

.badge-navy {
    @apply bg-blue-100 text-blue-800;
}

.badge-red {
    @apply bg-red-100 text-red-800;
}

.badge-blue {
    @apply bg-blue-100 text-blue-800;
}

.badge-orange {
    @apply bg-orange-100 text-orange-800;
}

.badge-dbeige {
    @apply bg-yellow-100 text-yellow-800;
}

.badge-lyellow {
    @apply bg-yellow-50 text-yellow-700;
}

.badge-default {
    @apply bg-gray-100 text-gray-800;
}
</style>